import styled from 'styled-components';

export const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
`;

export const Star = styled.span<{ $filled: boolean }>`
  font-size: 1.5rem;
  line-height: 1;
  color: ${({ $filled }) => ($filled ? 'var(--t-accent-color)' : 'var(--t-horizontal-vertical-rule)')};
  transition: color 0.2s ease-in-out;
`;

export const ScreenReaderText = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;